// 迁移内容
export default {
  'migrate.layout.text1':
    '請確保在2025.2.26（UTC+8）之前在新平臺完成你的遷移。舊平臺將在未來不久下架。新平臺將提供更好的功能服務，並繼承您在舊平臺上的剩余余額。如何你有任何問題，請聯系客服或發送郵件至 support@lightcdn.com。前往新平臺→',
  'migrate.layout.text2':
    '你已經在新平臺確認開始使用。舊平臺將在2025.2.26（UTC+8）下架。如有必要，請盡快下載歷史數據，並將CDN資源遷移到新平臺。轉到新平臺→',
  'migrate.MoveContent.title1': '遷移超簡單，復製激活即可！',
  'migrate.MoveContent.title2': '感謝你一如既往的支持! LightCDN將為你更好的服務！',
  'migrate.MoveContent.title1.step1': '復製你的專屬代碼：',
  'migrate.MoveContent.title1.step2.0': '前往',
  'migrate.MoveContent.title1.step2.1': '新平臺',
  'migrate.MoveContent.title1.step2.2': '概覽',
  'migrate.MoveContent.title1.step2.3': '，粘貼你的專屬代碼。',
  'migrate.MoveContent.title1.step3': '等待五分鐘，余額遷移，資源自動為你創建完成。',
  'migrate.MoveContent.title1.step4': '激活資源即可使用！',
  'migrate.MoveContent.title2.text': '遷移的過程需要5-10分鐘，請勿關閉窗口！',
  'migrate.MoveContent.title2.input': '請填入您的專屬代碼',
  'migrate.MoveContent.title2.start': '開始遷移',
  'migrate.MoveContent.title2.tip': '*此功能僅針對在舊平臺上還有正常業務資源的用戶',
  'migrate.MoveContent.title2.step1': '激活30天 500G 核心檔位額度...',
  'migrate.MoveContent.title2.step2': '正在為你準備遷移數據...',
  'migrate.MoveContent.title2.step3.0': '余額遷移...',
  'migrate.MoveContent.title2.step3.1': '資源創建...',
  'migrate.MoveContent.title2.step4': '遷移完畢，前往激活資源',
  'migrate.MoveContent.title2.step4.total': '資源創建情況：總計',
  'migrate.MoveContent.title2.step4.tip0':
    '請註意：資源創建範圍為在舊客戶端上依舊在正常使用的資源。',
  'migrate.MoveContent.title2.step4.tip1': '創建失敗的原因：',
  'migrate.MoveContent.title2.step4.tip2': '1.可能已在新平臺創建',
  'migrate.MoveContent.title2.step4.tip3':
    '2.可能受到網絡波動未創建成功，這些失敗的資源需要確認後自行手動創建',
  'migrate.MoveContent.title2.step4.tip4': '如果你失敗的資源過多，請發送郵件至support@lightcdn.com',
  'migrate.MoveContent.title2.step4.btn': '前往資源列表',
  'migrate.MoveContent.title2.text.btn': '點擊此處查看創建失敗的資源',
  'migrate.APIKey': '為了確保你的遷移過程不會出現問題，我們將在遷移期間暫時停止API的對外開放。',
  'migrate.monthPlanAndRecharge':
    '為了確保你的遷移過程不會出現問題，我們將在遷移期間暫時停止購買月度計劃和充值入口。',

  'migrate.register.title.0': '當前為LightCDN舊客戶端平臺，支持舊客戶將平臺內容遷移至新平臺，',
  'migrate.register.title.1': '暫時不開放註冊。',
  'migrate.register.title.2': '歡迎新用戶前往新客戶端平臺（',
  'migrate.register.title.3': '）使用。',
  'migrate.register.left.title': '舊用戶的遷移指南',
  'migrate.register.left.1.0': '前往',
  'migrate.register.left.1.1': '舊平臺 → 主頁',
  'migrate.register.left.1.2': '，復製你的專屬代碼。',
  'migrate.register.left.2.0': '在當前頁面的遷移窗口中粘貼復製的專屬代碼。',
  'migrate.register.left.2.1': '',
  'migrate.register.left.2.2': '',
  'migrate.register.left.3': '單資源僅需要等待幾秒即可完成。自動為你遷移余額，創建資源。',
  'migrate.register.left.4': '激活資源，完成DNS解析即可使用！',
  'migrate.register.right.title.1': '時間節點通知',
  'migrate.register.right.1.0': '遷移開始',
  'migrate.register.right.1.1':
    '新平臺開放，你可以選擇在合適的時間開始遷移資源，我們會協助你一鍵創建已有的資源，並轉移你的余額（500G的核心網絡流量無論是否用完都將會被重置，我們希望試用的客戶也一並遷移）。單資源遷移只有幾秒，重新dns解析即可，最小程度減少你的業務影響。',
  'migrate.register.right.1.2':
    '舊客戶端平臺會關閉充值和資源創建。已有的資源可以正常操作，不影響加速直到你遷移到新平臺。',
  'migrate.register.right.title.2': '遷移結束',
  'migrate.register.right.2.0':
    '舊平臺下架，這將意味著你在舊平臺的資源停止加速，若你至此還沒遷移，業務將會中斷。',
};
